import crypto from 'crypto-js';
import React, { useEffect } from 'react';
import Cookies from 'react-cookies';
import COOKIES from '../../config/cookies/cookies';
import { LOYALTY_BANNER_CONFIG } from '../../config/setup/setup';
import { initLibrary } from './initLibrary';

/** Third party script inits to inject cashback banner into the site. Also generates a modal. */
const LoyaltyBanner = () => {
  const { key, id } = LOYALTY_BANNER_CONFIG[process.env.NEXT_PUBLIC_SITE];
  const userEmail = Cookies.load(COOKIES.userEmail);
  const ctoBundle = Cookies.load(COOKIES.ctoBundle);
  const trimmedLowercasedEmail = userEmail?.trim().toLowerCase();
  const hashedEmail = crypto
    .SHA256(trimmedLowercasedEmail)
    .toString(crypto.enc.Hex);
  useEffect(() => {
    if (ctoBundle) {
      initLibrary(key, hashedEmail);
    } else {
      initLibrary(key);
    }
  }, []);

  return <div id={id} />;
};

export default LoyaltyBanner;
